import { Swiper } from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

Swiper.use([Navigation, Autoplay]);

document.addEventListener('DOMContentLoaded', function () {
	const ctas = document.querySelectorAll('.block-footer-cta');
	if (!ctas.length) return;

	ctas.forEach((cta, index) => {
		const columns = cta.querySelectorAll('.block-footer-column__content');
		if (columns.length < 2) return;

		const column = columns[1];
		const blockContents = column.querySelectorAll('.block-content');
		if (!blockContents.length) return;

		// Create swiper-wrapper
		const wrapper = document.createElement('div');
		wrapper.classList.add('swiper-wrapper');

		blockContents.forEach((el) => {
			el.classList.add('swiper-slide');
			wrapper.appendChild(el);
		});

		// Create unique swiper container
		const swiperContainer = document.createElement('div');
		swiperContainer.classList.add('swiper', 'footer-awards-swiper');
		swiperContainer.appendChild(wrapper);

		// Add to column
		column.appendChild(swiperContainer);

		// Create unique nav buttons
		const prev = document.createElement('button');
		prev.classList.add('swiper-button-prev', 'swiper-button--outline');
		prev.innerHTML = '←';

		const next = document.createElement('button');
		next.classList.add('swiper-button-next', 'swiper-button--outline');
		next.innerHTML = '→';

		column.appendChild(prev);
		column.appendChild(next);

		// Initialize Swiper for this instance
		new Swiper(swiperContainer, {
			loop: true,
			slidesPerView: 1,
			autoplay: {
				delay: 400000,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: prev,
				nextEl: next,
			},
		});
	});
});
